"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignInEndpoint = exports.GuestTokenEndpoint = exports.PwdRestoreEndpoint = exports.LogInEndpoint = exports.SignUpEndpoint = void 0;
exports.SignUpEndpoint = require("./sign-up");
exports.LogInEndpoint = require("./login");
exports.PwdRestoreEndpoint = require("./pwd-restore");
exports.GuestTokenEndpoint = require("./guest-token");
exports.SignInEndpoint = require("./sign-in");
